import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import BASE_URL from "api/Api";
import {apiFetch} from "api/Api";

function UpdateAbout() {
  const { id } = useParams();

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    points: "",
    image: null,
  });

  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchAbout();
  }, []);

  const fetchAbout = async () => {
    try {
      const res = await apiFetch(`leader_admin/get_about_data`,{
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
const data = res.data;
console.log("Fetched About Data:", data);
console.log(BASE_URL+ data.image_path);
      setFormData({
        title: data.title || "",
        description: data.description || "",
        points: (data.points ||""),
        image: null,
      });

      setPreview(data.image_path ? `${BASE_URL}${data.image_path}` : null);
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({
        ...prev,
        image: file,
      }));
      setPreview(URL.createObjectURL(file));
    }
  };

 const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    setLoading(true);

    const payload = new FormData();
    payload.append("title", formData.title);
    payload.append("description", formData.description);
    payload.append("points", formData.points);

    if (formData.image) {
      payload.append("image", formData.image); 
    }

    await apiFetch(`leader_admin/update_about`, {
      method: "PUT",
      body: payload,
    });

    alert("About section updated successfully");
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};
  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid mt-4" style={{ fontSize: "0.9rem" }}>

        {/* Gradient Header */}
        <div
          className="p-4 rounded-4 shadow-lg mb-4 text-white d-flex justify-content-between align-items-center"
          style={{
            background: "linear-gradient(135deg, #002B5B, #007BFF)",
          }}
        >
          <div>
            <h4 className="fw-bold mb-1" style={{ fontSize: "1.2rem" }}>
              ✏ Update About Section
            </h4>
            <small style={{ fontSize: "0.85rem" }}>Edit about content details</small>
          </div>

          <Link
            to="/about_list"
            className="btn btn-light fw-semibold"
            style={{ fontSize: "0.8rem" }}
          >
            About List
          </Link>
        </div>

        {/* Main Card */}
        <div className="card shadow-lg rounded-4 border-0">
          <div className="card-body p-4">

            <form onSubmit={handleSubmit}>
              <div className="row g-4">

                {/* Title */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    Title
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* Image Upload */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    Change Image
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    accept="image/*"
                    onChange={handleImageChange}
                  />

                  {preview && (
                    <div className="mt-3">
                      <img
                        src={preview}
                        alt="Preview"
                        className="rounded shadow-sm"
                        style={{
                          width: "120px",
                          height: "90px",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  )}

                
                </div>

                {/* Description */}
                <div className="col-12">
                  <label className="form-label fw-semibold">
                    Description
                  </label>
                  <textarea
                    className="form-control"
                    rows="4"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* Points */}
                <div className="col-12">
                  <label className="form-label fw-semibold">
                    Points (Comma Separated)
                  </label>
                  <textarea
                    className="form-control"
                    rows="3"
                    name="points"
                    value={formData.points}
                    onChange={handleChange}
                  />
                  <small className="text-muted">
                    Separate points using comma (,)
                  </small>
                </div>

              </div>

              {/* Submit */}
              <div className="text-end mt-4">
                <button
                  type="submit"
                  className="btn btn-primary px-5 fw-semibold"
                  style={{ fontSize: "0.85rem" }}
                  disabled={loading}
                >
                  {loading ? "Updating..." : "Update About"}
                </button>
              </div>

            </form>

          </div>
        </div>

      </div>
    </DashboardLayout>
  );
}

export default UpdateAbout;